var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconOptionSocial = function SvgIconOptionSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#F8F9FD",
    rx: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M15.25 17a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H16a.75.75 0 0 1-.75-.75M15.25 22a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H16a.75.75 0 0 1-.75-.75M15.25 27a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H16a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgIconOptionSocial;